import { Printd } from 'printd';

export default {
    inserted: function (el, binding) {
        el.addEventListener('click', (evt) => {
            evt.preventDefault();

            const printElement = document.getElementById(binding.value);
            const d = new Printd();

            // Styling to enable background graphics on printed grocery list so that user can see checkboxes
            const cssText = `
                #grocery-list-print-section {
                    -webkit-print-color-adjust: exact !important;   /* Chrome, Safari */
                    color-adjust: exact !important;                 /*Firefox*/
                }
            `;

            const styles = [
                'https://www.heart.org/dist/common/app.css',
                'https://www.heart.org/dist/common/vendor.css',
                cssText
            ];
            d.print(printElement, styles);
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/print-element.js